import React, { useEffect } from 'react';
import ButtonComp from '@components/UI/Button/Index';
import { useLocation, useNavigate } from 'react-router-dom';
import PageWrapper from '@components/UI/PageWrapper/Index';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@hooks/auth/auth-config';
import { useAppAuth } from '@contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const { email, loading } = useAppAuth();

  useEffect(() => {
    if (!loading && email) {
      navigate(from, { replace: true });
    }
  }, [email, loading, navigate, from]);

  const handleLoginMsalManual = async () => {
    sessionStorage.setItem('authMode', 'manual');
    await instance.loginRedirect(loginRequest);
  };

  return (
    <PageWrapper>
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="card p-0 shadow"
          style={{
            maxWidth: '600px',
            width: '90vw',
            borderRadius: '16px'
          }}>
          <div
            className="position-relative"
            style={{
              width: '100%',
              height: '30vw',
              minHeight: 220,
              maxHeight: 340,
              overflow: 'hidden',
              borderTopLeftRadius: '16px',
              borderTopRightRadius: '16px',
              background: '#f8f9fa'
            }}>
            <img
              src='/login.webp'
              alt='Background Senac'
              className='w-100 h-100 object-fit-cover'
              style={{ objectFit: 'cover' }}
            />
            <img
              src='/senac.webp'
              alt='Logo Senac'
              className="position-absolute top-0 end-0 m-3"
              style={{
                height: 60,
                width: 'auto',
                background: 'rgba(255,255,255,0.9)',
                borderRadius: 8,
                padding: 4
              }}
            />
          </div>
          <div className="p-4">
            <h2 className='text-center mb-4' style={{ fontSize: 20 }}>
              Sistema de Gestão e Serviços para Governança e Integridade
            </h2>
            <div className='d-flex justify-content-center gap-3'>
              <ButtonComp
                title={"REALIZAR LOGIN NO SISTEMA"}
                onClick={handleLoginMsalManual}
                buttonColor={"#014687"}
                classnameIcon={"fa-solid fa-right-to-bracket"}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Login;
